import React from 'react';
import PropTypes from 'prop-types';
import {
	headerStyle,
	headerInnerWrapperStyle,
	headerTextWrapperStyle,
	titleStyle,
	subTitleStyle,
} from './styles';

export const PageHeader = ({
	background,
	icon,
	titleText,
	titleTextColor,
	subTitleText,
	subTitleTextColor,
	pageNav,
}) => (
	<header className={headerStyle(background)} data-component="PageHeader">
		<div className={headerInnerWrapperStyle}>
			<div className={headerTextWrapperStyle(!!icon)}>
				{icon && (
					<div>
						<img src={icon} alt="" />
					</div>
				)}
				<div>
					<h1 className={titleStyle(titleTextColor)}>{titleText}</h1>
					{subTitleText && <p className={subTitleStyle(subTitleTextColor)}>{subTitleText}</p>}
				</div>
			</div>
			{pageNav}
		</div>
	</header>
);

PageHeader.propTypes = {
	background: PropTypes.string,
	icon: PropTypes.string,
	titleText: PropTypes.string,
	titleTextColor: PropTypes.string,
	subTitleText: PropTypes.string,
	subTitleTextColor: PropTypes.string,
	pageNav: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/components/shared/pageHeader/component.js